import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['changeActivityType'];

  connect() {
    this.element.addEventListener('selectInputValueChanged', this.switchActivityType);
  }

  disconnect() {
    this.element.removeEventListener('selectInputValueChanged', this.switchActivityType);
  }

  switchActivityType = (event) => {
    if (event.detail.inputId === 'oim_case_activity_type') {
      this.changeActivityTypeTarget.click();
    }
  };
}
